/**
 * Pure keyboard input-restriction helpers — no state, no DI.
 *
 * Moved out of DashboardComponent (allowOnlyNumbers, allowAlphaNumeric,
 * allowAlphabeticOnly) as part of the dashboard.component.ts refactor.
 */
export function allowOnlyNumbers(event: KeyboardEvent) {
  const charCode = event.which ? event.which : event.keyCode;
  const isMainKeyboardNumber = charCode >= 48 && charCode <= 57;
  const isNumpadNumber = charCode >= 96 && charCode <= 105;
  // Backspace (8), Tab (9), Enter (13), Delete (46), Arrow keys (37-40)
  const isSpecialKey = [8, 9, 13, 46, 37, 38, 39, 40].includes(charCode);

  if (!isMainKeyboardNumber && !isNumpadNumber && !isSpecialKey) {
    event.preventDefault();
  }
}

export function allowAlphaNumeric(event: KeyboardEvent) {
  const charCode = event.which ? event.which : event.keyCode;

  // Allow numeric (0-9)
  const isNumeric = charCode >= 48 && charCode <= 57;

  // Allow uppercase alphabetic (A-Z)
  const isUppercase = charCode >= 65 && charCode <= 90;

  // Allow lowercase alphabetic (a-z)
  const isLowercase = charCode >= 97 && charCode <= 122;

  if (!isNumeric && !isUppercase && !isLowercase) {
    event.preventDefault();
  }
}

export function allowAlphabeticOnly(event: KeyboardEvent) {
  const key = event.key;

  const isAlphabetic = /^[a-zA-Z]$/.test(key);

  const isSpace = key === ' ';

  const isControlKey = [
    'Backspace',
    'Delete',
    'Tab',
    'ArrowLeft',
    'ArrowRight',
    'ArrowUp',
    'ArrowDown',
    'Home',
    'End',
  ].includes(key);

  if (!isAlphabetic && !isSpace && !isControlKey) {
    event.preventDefault();
  }
}
